export default __webpack_public_path__ + "static/media/drive-time.67c74379.svg";